var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Depot from '../_shared/depot';
const Logo = (_a) => {
    var { source: { content, alt } } = _a, commonProps = __rest(_a, ["source"]);
    const altText = alt || 'Logo';
    const { width, height, children: svgChildren } = content.props;
    return Depot.createElement('svg', Object.assign(Object.assign({}, commonProps), { viewBox: `0 0 ${width} ${height}`, width: `${width}px`, height: `${height}px`, role: 'img', id: altText }), React.createElement(React.Fragment, null,
        React.createElement("title", null, altText),
        React.createElement("desc", null, altText),
        svgChildren));
};
export default Logo;
//# sourceMappingURL=index.js.map